import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import SeoContent from './components/SeoContent';
import ArticlePreviewGrid from './components/ArticlePreviewGrid';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />
      <HeroSection />
      <CategorySection />
      <ArticlePreviewGrid />
      <SeoContent />
      <ContactSection />
      <Footer />
    </main>
  );
}